import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from 'src/redux-store/appStore';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const isLogout = useSelector((state: RootState) => state.logout.isLogout);

  const { pathname, search } = location;

  // ✅ 1. Define paths that should be redirectable to after login
  const redirectablePaths = [
    '/bid-portal/home/bid-details/', // Base dynamic route
    '/bid-portal/home/po-details/',
    '/bid-portal/Admin/vendors'
  ];

  // 2. Check if current path contains any valid redirectable route
  const isRedirectable = redirectablePaths.some((path) =>
    pathname.includes(path)
  );

  console.log(isLogout, isRedirectable, 'isLogoutisLogout');

  if (isRedirectable) {
    if (!isLogout) {
      // Save full redirect path including query parameters only if the user is not logged in
      sessionStorage.setItem('redirectPath', `${pathname}${search}`);
    }
  }

  if (!userDetails?.EmailID) {
    // Redirect to login page
    return (
      <Navigate
        to={`${pathname.split('/').slice(0, 4).join('/')}/login`}
        replace
      />
    );
  }

  const isPasswordUpdatedByAdmin =
    userDetails?.IsPasswordUpdatedByAdmin === true;

  const isOnChangePasswordPage =
    pathname.includes('/bid-portal/Admin/my-profile/change-password') ||
    pathname.includes('/bid-portal/profile/change-password');

  if (isPasswordUpdatedByAdmin && !isOnChangePasswordPage) {
    const segments = pathname.split('/');
    const basePath = segments.slice(0, 4).join('/'); // /:state/:township/:uuid
    const isAdmin =
      userDetails?.UserRole === 'Admin' ||
      userDetails?.UserRole === 'General Admin';

    const target = isAdmin
      ? `${basePath}/bid-portal/Admin/my-profile/change-password`
      : `${basePath}/bid-portal/profile/change-password`;

    return <Navigate to={target} replace />;
  }

  return children;
};

export default ProtectedRoute;
